/** A DOM id for a category's section, e.g. ("category", "Code health") → "category-code-health". */
export const categoryId = (prefix: string, category: string): string =>
  `${prefix}-${category.toLocaleLowerCase("en-US").replace(/[^a-z0-9]+/g, "-")}`;
